export default {
  isFetchedAllTransactions(state) {
    return Array.isArray(state.items) ?
      state.totalCount === state.items.length :
      false;
  },

  isFetchedToEnd(state) {
    if (state.items.length > 0 && state.fetchCount < state.maxFetchCount) {
      const lastTransaction = state.items[state.items.length - 1];
      return state.totalCount === parseInt(lastTransaction.rownum, 10);
    }
    return true;
  },

  endCursor(state) {
    if (state.items.length > 0) {
      const lastTransaction = state.items[state.items.length - 1];
      return parseInt(lastTransaction.rownum, 10);
    }
    return null;
  },

  transactionFilters(state) {
    return {
      ...state.filters,

      areaMin: parseInt(state.filters.areaMin, 10),
      areaMax: parseInt(state.filters.areaMax, 10),
      sellMin: parseInt(state.filters.sellMin, 10),
      sellMax: parseInt(state.filters.sellMax, 10),
      rentMin: parseInt(state.filters.rentMin, 10),
      rentMax: parseInt(state.filters.rentMax, 10),
      ftSellMin: parseInt(state.filters.ftSellMin, 10),
      ftSellMax: parseInt(state.filters.ftSellMax, 10),
      ftRentMin: parseInt(state.filters.ftRentMin, 10),
      ftRentMax: parseInt(state.filters.ftRentMax, 10),
    };
  },
};
